// src/components/IconButton.jsx
export default function IconButton({ icon, active, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`p-3 rounded-xl transition-all duration-200 shadow-sm
        ${active
          ? "bg-gradient-to-r from-blue-600 to-cyan-600 text-white shadow-md shadow-blue-300/40"
          : "text-slate-500 hover:text-blue-600 hover:bg-white/80"
        }`}
    >
      {icon}
    </button>
  );
}
